import React from 'react';
import { RouteComponentProps } from 'react-router';
import PageContainer from './PageContainer';
import PaddedContent from '../components/housing/PaddedContent';
import styled from 'styled-components/macro';
import { themeColors } from '../theme/theme';
import { H1 } from '../components/common';
import { useMessageGetter } from 'react-message-context';
import { useAppState } from '../context/appContext';

const IFrameContainer = styled.div`
  width: 100%;
  height: 1500px;

  iframe {
    width: 100%;
    height: 100%;
    border: 2px solid ${themeColors.m2Black};
    border-radius: 20px;
  }
`;

const PublicEventsPage = ({ history }: RouteComponentProps) => {
  const t = useMessageGetter('living.events');
  const { language } = useAppState();

  return (
    <PageContainer history={history}>
      <PaddedContent>
        <H1>{t('title')}</H1>
        <IFrameContainer>
          <iframe
            src={`https://www.lyyti.fi/e/y-saatio/?q=aad75a657b26a99aa0451a319b882d16&lang=${language}`}
            title={t('title')}
          />
        </IFrameContainer>
      </PaddedContent>
    </PageContainer>
  );
};

export default PublicEventsPage;
